import { useAppliedOfferMetadata } from 'features/offer/hooks/use-applied-offer-metadata';
import { keyBy, uniqBy } from 'lodash-es';

import { selectors, useAppSelector } from 'state/global-state';
import {
  ICartEntryType,
  useInRestaurantRedemptionContext,
} from 'state/loyalty/in-restaurant-redemption';
import {
  LoyaltyOffer,
  appOfferToLoyaltyOffer,
  isAppPersonalizedOffer,
  isSanityOfferListItem,
} from 'state/loyalty/types';

export const useLoyaltyOffersInCart = () => {
  const { inRestaurantRedemptionCart } = useInRestaurantRedemptionContext();
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const cmsOffers = useAppliedOfferMetadata();
  const personalizedOffers = useAppSelector(selectors.loyalty.selectAppPersonalizedOffers);

  const getLoyaltyOffersInCart = () => {
    const appliedOffersMap = keyBy(appliedOffers, 'id');
    const inRestaurantRedemptionMap = keyBy(inRestaurantRedemptionCart, cartEntry =>
      cartEntry.type === ICartEntryType.OFFER ? cartEntry.details.offer._id : cartEntry.referenceId
    );

    const offers = uniqBy(
      [...personalizedOffers, ...cmsOffers.filter(isSanityOfferListItem)],
      'loyaltyEngineId'
    );
    return offers
      ?.filter(offer => {
        if (!offer.loyaltyEngineId || !offer._id) {
          return false;
        }
        return appliedOffersMap[offer.loyaltyEngineId] || inRestaurantRedemptionMap[offer._id];
      })
      .map(o => (isAppPersonalizedOffer(o) ? appOfferToLoyaltyOffer(o) : o));
  };

  // For now we can have only one offer in cart, so taking the first one is valid.
  const getLoyaltyOfferInCart = (): LoyaltyOffer | undefined => {
    return getLoyaltyOffersInCart()[0];
  };

  return {
    getLoyaltyOfferInCart,
  };
};
